export default "__VITE_ASSET__fAHIRiNL__"